import { subscribe, EVENTS } from "ia-util-pubsub";

// Matches --ia-transition-duration so the .is-leaving fade finishes before removal
const DISMISS_TRANSITION_MS = 300;
const MAX_STACKED_TOASTS = 3;

class IaNotification extends HTMLElement {
  connectedCallback() {
    this.querySelector(".ia-notification__close")?.addEventListener("click", () => this.dismiss());

    this.duration = parseInt(this.dataset.duration, 10) || 0;
    if (this.duration > 0) {
      // Timed messages must not vanish mid-read (WCAG 2.2.1)
      this.addEventListener("pointerenter", this.stopTimer.bind(this));
      this.addEventListener("focusin", this.stopTimer.bind(this));
      this.addEventListener("pointerleave", this.startTimer.bind(this));
      this.addEventListener("focusout", this.startTimer.bind(this));
      this.startTimer();
    }
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  startTimer() {
    this.stopTimer();
    this.timer = setTimeout(() => this.dismiss(), this.duration);
  }

  stopTimer() {
    clearTimeout(this.timer);
  }

  dismiss() {
    this.stopTimer();
    this.classList.add("is-leaving");
    setTimeout(() => this.remove(), DISMISS_TRANSITION_MS);
  }
}

if (!customElements.get("ia-notification")) {
  customElements.define("ia-notification", IaNotification);
}

class IaToastRegion extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector("template");
    this.defaultDuration = parseInt(this.dataset.duration, 10) || 5000;
    this.unsubscribeShow = subscribe(EVENTS.toastShow, (event) => this.show(event.detail));
    window.iaToast = this;
  }

  disconnectedCallback() {
    this.unsubscribeShow?.();
  }

  show(options = {}) {
    const {
      state = "info",
      title = "",
      text = "",
      actionLabel = "",
      actionUrl = "",
      dismissible = false,
      duration = this.defaultDuration,
    } = options;

    const toast = this.template.content.firstElementChild.cloneNode(true);
    toast.classList.add(`ia-notification--${state}`);
    if (duration > 0) toast.dataset.duration = duration;

    toast.querySelector(".ia-notification__text").textContent = text;

    const titleElement = toast.querySelector(".ia-notification__title");
    title ? (titleElement.textContent = title) : titleElement.remove();

    const actionElement = toast.querySelector(".ia-notification__action");
    if (actionLabel && actionUrl) {
      actionElement.textContent = actionLabel;
      actionElement.href = actionUrl;
    } else {
      actionElement.remove();
    }

    if (!dismissible) toast.querySelector(".ia-notification__close").remove();

    const stacked = this.querySelectorAll(".ia-notification:not(.is-leaving)");
    if (stacked.length >= MAX_STACKED_TOASTS) stacked[0].dismiss();

    this.append(toast);
    return toast;
  }
}

if (!customElements.get("ia-toast-region")) {
  customElements.define("ia-toast-region", IaToastRegion);
}
